import React, { Fragment } from 'react'
import classnames from 'classnames'
import Notifications from '../notifications/notifications'
import Dropdown from './dropdown'
import MessengerGate from '../messenger/gate'
import store from '../../admin/store'
import CheerModalPop from '../shared/cheer-modal'
import {
    withRouterConnectWrapper,
    i18n,
} from '../../validator'
import Configurator from '../../configurator'
import SnIcon from '../../front/components/shared/sn-icon'

import {
    LoginButton,
    CitiesLoginButton,
    setSuccessAction,
} from './login-buttons'
import Button from '../../front/components/shared/sn-button'

const userDefaultLogo = '/images/man-silhouette.svg'
const logoSnect = '/images/sn-logo-new.svg'
const logoOstrava = '/images/ostrava/svo-nav-logo-cropped.svg'
const logoOlomouc = '/images/olomouc/svol-nav-logo.svg'
const logoCheb = '/images/cheb/svch-nav-logo.svg'

import SearchInput from '../shared/search/search-input'
import EntitiesStripe from './entities-stripe'
import { setSystemRedirectLinks } from '../../admin/actions/system-redirect'
import {
    S_SPORTUJ_V_CHEBU,
    S_SPORTUJ_V_OLOMOUCI,
    S_SPORTUJ_V_OSTRAVE,
} from '../../consts'
import { sportnectNavDropdowns } from './dropdowns/sportnect'
import { citiesNavDropdowns } from './dropdowns/cities'
import { sportnectNavDropdownsResponsive } from './dropdowns/sportnect-responsive'
import { ImageResized } from '../shared/webp-image-resized'
import Link from '../../front/components/shared/sn-link'
import { checkNewNotifications } from '../notifications/helpers'
import ReactInterval from 'react-interval'
import WelcomingModal from './welcoming-modal'

@i18n()
class Navigator extends Configurator {
    static RESPONSIVE_MENU_WIDTH_BREAK = 768

    constructor(props) {
        super(props)

        const dropdowns = this.isResponsiveMenu() ? sportnectNavDropdownsResponsive(props.t, this.config) : sportnectNavDropdowns(props, this.config)

        this.state = {
            showMenuResponsive: false,
            submenuOpen: false,
            isResponsiveMenu: this.isResponsiveMenu(),
            toggleResponsiveMenu: this.toggleResponsiveMenu,
            dropdowns: this.isSportnectSystem() ? dropdowns : citiesNavDropdowns(props),
            searchClicked: false,
        }
    }

    componentDidMount() {
        window.addEventListener('resize', () => {
            this.setState({ isResponsiveMenu: this.isResponsiveMenu() })
        })

        if (this.props.authedUser) {
            checkNewNotifications()
        }
    }

    /**
     * Apply responsive?
     *
     * @returns {boolean}
     */
    isResponsiveMenu = () => window.innerWidth < Navigator.RESPONSIVE_MENU_WIDTH_BREAK


    /**
     * Show / hide the responsive menu
     *
     * @param {boolean} forceStatus
     */
    toggleResponsiveMenu = (forceStatus = null) => {
        if (this.isResponsiveMenu()) {
            this.setState({ showMenuResponsive: forceStatus !== null ? forceStatus : !this.state.showMenuResponsive })
        }
    }

    /**
     * Render menu logo
     *
     * @returns {*}
     */
    renderMenuLogo = () => {
        const {
            authedUser,
            location,
        } = this.props

        const locationPath = location?.pathname || ''

        let logo = logoSnect

        switch (this.config.REACT_APP_SYSTEM) {
            case S_SPORTUJ_V_OSTRAVE:
                logo = logoOstrava
                break
            case S_SPORTUJ_V_OLOMOUCI:
                logo = logoOlomouc
                break
            case S_SPORTUJ_V_CHEBU:
                logo = logoCheb
                break
        }

        return (
            <Link
                to="/"
                className={classnames({
                    'mr-1 mr-sm-4': true,
                    'logo': logo === logoSnect,
                    'm-auto': !authedUser && locationPath === '',
                    'logo--full': logo === logoSnect && !authedUser,
                })}
                onClick={() => this.toggleResponsiveMenu(false)}
            >
                <img src={logo} alt="logo" />
            </Link>
        )
    }

    /**
     * Render only first letter of surname
     * @param {string} surname
     * @returns {*}
     */
    renderShortSurname = surname => surname?.substr?.(0, 1)

    renderLoginModalPop = () => {
        const {
            login,
            t,
        } = this.props

        const {
            loginRoute,
            signupRoute,
        } = this.config

        if (!login.modalVisible) {
            return null
        }

        return (
            <div className="position-relative">
                <div
                    className="Navbar-login__overlay"
                    onClick={() => store.dispatch({ type: 'TOGGLE_LOGIN_MODAL' })}
                />
                <div className="Navbar-login__modal-pop">
                    <div className="d-flex align-items-end flex-column">
                        <WelcomingModal />
                        <div className="d-flex w-100 justify-content-center">
                            {!this.isSportnectSystem() && (
                                <Button
                                    onClick={() => {
                                        store.dispatch({ type: 'TOGGLE_LOGIN_MODAL' })
                                        setSuccessAction()
                                        setSystemRedirectLinks(null, loginRoute, true)
                                    }}
                                    className="btn btn-outline-color-brand btn-lg mt-2"
                                >
                                    {t('login')}
                                </Button>
                            )}
                            {this.isSportnectSystem() && (
                                <div className="d-flex justify-content-center align-items-center p-3 w-100">
                                    <Link
                                        to={{
                                            pathname: loginRoute,
                                        }}
                                        onClick={setSuccessAction}
                                        className="btn btn-lg mt-2 mr-2"
                                    >
                                        {t('login')}
                                    </Link>
                                    <Link
                                        to={{
                                            pathname: signupRoute,
                                        }}
                                        onClick={setSuccessAction}
                                        className="btn btn-color-brand btn-lg mt-2"
                                    >
                                        {t('register')}
                                    </Link>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div >
        )
    }

    /**
     * Render search button
     * @returns {*}
     */
    renderSearchButton = () => {
        const { t } = this.props

        return (
            <Link
                className="icon-link p-0"
                title={t('searchLabel')}
                to={`/${this.config.REACT_APP_TRANSLATION_ROUTES.entities}`}
                onClick={() => this.setState({ searchClicked: true })}
            >
                <SnIcon className="sn-search" />
                <p>{t('searchLabel')}</p>
            </Link>
        )
    }

    /**
     * Render profile link content
     *
     * @returns {*}
     */
    renderProfileLinkContent = () => {
        const {
            t,
            authedUser,
        } = this.props

        return (
            <Fragment>
                <ImageResized
                    src={authedUser?.image?.data?.path}
                    size="avatar"
                    alt="profile"
                    defaultSrc={userDefaultLogo}
                />
                <p>{t('me')}</p>
            </Fragment>
        )
    }

    /**
     * Check if can show entities stripe
     *
     * On desktop
     * For Sportnect is showed if page is list of some entity (eg. All, Events, Clubs,...) and user is logged
     * For Cities  is visible always
     *
     * In responsive
     * For Sportnect and Cities is visible if page is list of some entity (eg. All, Events, Clubs,...)
     *
     * @param {string} locationPath
     * @param {boolean} isResponsive
     * @return {boolean}
     */
    canShowEntitiesStripe = (locationPath = '', isResponsive) => {
        const { REACT_APP_TRANSLATION_ROUTES: routes } = this.config

        if (!isResponsive) {
            return true
        }

        const locationPathWithoutSlash = locationPath.replace('/', '')
        return Object.values(routes).some(item => item === locationPathWithoutSlash)
    }

    /**
     * Renders searchbar and entities.
     * Used in renderResponsiveMenu()
     * @param {string} locationPath 
     * @returns {JSX.Element}
     */
    renderSearchAndEntities = locationPath => {
        const { searchClicked } = this.state
        const canShowEntitiesStripeBool = this.canShowEntitiesStripe(locationPath, true)

        if (!searchClicked) {
            return ""
        }

        if (searchClicked && canShowEntitiesStripeBool) {
            return (
                <>
                    <div className="separator-line-h" />
                    <SearchInput />
                    <div className="separator-line-h" />
                    <EntitiesStripe />
                </>
            )
        }

        if (searchClicked && !canShowEntitiesStripeBool) {
            return (
                <>
                    <div className="separator-line-h" />
                    <EntitiesStripe />
                </>
            )
        }
    }

    /**
     ** Render responsive variant of menu
     *
     * @param {string} locationPath
     * @return {*}
     */
    renderResponsiveMenu = locationPath => {
        const {
            authedUser,
            fetchingAuthedUser,
            t,
        } = this.props

        const { landing } = { ...this.state.dropdowns }

        return (
            <div className="Navbar__responsive">
                <div className={classnames({
                    'Navbar__responsive-container': true,
                    'justify-content-center': !authedUser && locationPath === '',
                    'justify-content-between': !authedUser && locationPath !== '',
                })}>
                    <span className="Navbar__responsive-container-logo">{this.renderMenuLogo()}</span>

                    {authedUser &&
                        <div className="Navbar__responsive-container-box">
                            <ul className="Navbar__responsive-container--links">
                                <li>
                                    {this.renderSearchButton()}
                                </li>
                                <li>
                                    <Link
                                        className="icon-link"
                                        to="/"
                                        title={t('home')}
                                        onClick={() => this.toggleResponsiveMenu(false)}
                                    >
                                        <SnIcon className="sn-home" />
                                        <p>{t('home')}</p>
                                    </Link>
                                </li>
                                <li>
                                    <MessengerGate />
                                </li>
                                <li>
                                    <Notifications />
                                </li>
                                <Dropdown
                                    withLogout
                                    authedUser={authedUser}
                                    containerClassname="icon-link"
                                    iconClassname="sn-bars"
                                    mainLink={t('menu')}
                                    elements={[
                                        ...this.state.dropdowns.create,
                                        ...this.state.dropdowns.menu,
                                    ]}
                                    citiesElements={this.state.dropdowns.cities}
                                    familyElements={this.state.dropdowns.family || null}
                                    forceActive={locationPath.includes('/admin')}
                                    renderShortSurname={this.renderShortSurname}
                                    {...this.state}
                                />
                            </ul>
                        </div>
                    }
                    {!authedUser &&
                        <div className="Navbar__container-landing-page">
                            {this.renderSearchButton()}

                            {!this.isSportnectSystem() && !fetchingAuthedUser &&
                                <CitiesLoginButton />
                            }

                            {this.isSportnectSystem() &&
                                <Fragment>
                                    <LoginButton />
                                    <Dropdown
                                        containerClassname="icon-link"
                                        iconClassname="sn-bars"
                                        mainLink={t('menu')}
                                        elements={landing}
                                        {...this.state}
                                    />
                                </Fragment>
                            }
                        </div>
                    }
                </div>

                {this.renderSearchAndEntities(locationPath)}

                <div className="separator-line-h" />
            </div>
        )
    }

    /**
     * Render desktop variant of menu
     *
     * @param {string} locationPath
     * @return {*}
     */
    renderMainMenu = locationPath => {
        const {
            authedUser,
            fetchingAuthedUser,
            t,
        } = this.props

        const { showMenuResponsive } = this.state

        return (
            <Fragment>
                <div className={classnames({
                    'Navbar': true,
                    'Navbar__responsive-content': showMenuResponsive,
                })}>
                    <div
                        className={classnames({
                            'Navbar__container position-relative': true,
                            'justify-content-between': !authedUser,
                            'Navbar__container-sn-landing px-3 px-lg-5': this.isSportnectSystem(),
                            'container': !this.isResponsiveMenu(),
                        })}
                    >
                        <div className="d-flex align-items-center">
                            {!showMenuResponsive && this.renderMenuLogo()}
                            <SearchInput onFocusRedirectToEntities />
                        </div>

                        {authedUser &&
                            <ul className="Navbar__container--links">
                                <li
                                    className={classnames({
                                        'Navbar__container--links-link-active': locationPath === '/' &&
                                            !this.isResponsiveMenu(),
                                    })}
                                >
                                    <Link
                                        className="icon-link"
                                        to="/"
                                        title={t('home')}
                                        onClick={() => this.toggleResponsiveMenu(false)}
                                    >
                                        <SnIcon className="sn-home" />
                                        <p>{t('home')}</p>
                                    </Link>
                                </li>
                                <li>
                                    <MessengerGate />
                                </li>
                                <li>
                                    <Notifications />
                                </li>
                                <li>
                                    {!this.isSportnectSystem() &&
                                        <Button
                                            href={`https://www.sportnect.com/users/${authedUser?.slug}`}
                                            className="icon-link"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            {this.renderProfileLinkContent()}
                                        </Button>
                                    }
                                    {this.isSportnectSystem() &&
                                        <Link
                                            className="icon-link"
                                            to={`/users/${authedUser?.slug}`}
                                        >
                                            {this.renderProfileLinkContent()}
                                        </Link>
                                    }
                                </li>
                                <Dropdown
                                    showResponsive
                                    containerClassname="icon-link"
                                    iconClassname="sn-circle-plus text-color-brand"
                                    mainLink={t('create')}
                                    elements={this.state.dropdowns.create}
                                    forceActive={locationPath.includes('/admin')}
                                    {...this.state}
                                />
                                <Dropdown
                                    showResponsive
                                    withLogout
                                    containerClassname="icon-link"
                                    iconClassname="sn-bars"
                                    mainLink={t('menu')}
                                    elements={this.state.dropdowns.menu}
                                    citiesElements={this.state.dropdowns.cities}
                                    familyElements={this.state.dropdowns.family || null}
                                    forceActive={locationPath.includes('/admin')}
                                    {...this.state}
                                />
                            </ul>
                        }

                        {!authedUser &&
                            <div className="Navbar__container-landing-page">
                                {this.isSportnectSystem() &&
                                    <>
                                        <Link
                                            className="btn btn-circle font-weight-bold hover-underline"
                                            to="/signup"
                                        >
                                            {t('register')}
                                        </Link>

                                        <Link
                                            className="ml-0 btn btn-outline-color-brand btn-circle"
                                            to="/login"
                                        >
                                            {t('login')}
                                        </Link>
                                    </>
                                }
                                {!this.isSportnectSystem() && !fetchingAuthedUser &&
                                    <CitiesLoginButton />
                                }
                            </div>
                        }
                    </div>

                    {this.canShowEntitiesStripe(locationPath, false) &&
                        <Fragment>
                            <div className="separator-line-h" />
                            <EntitiesStripe />
                        </Fragment>
                    }
                </div>
                {this.canShowEntitiesStripe(locationPath, false) &&
                    <div className="Navbar__entities-stripe-offset" />
                }
            </Fragment>
        )
    }

    render() {
        const {
            location,
            className,
            authedUser,
        } = this.props

        const locationPath = location?.pathname || ''

        return (
            <Fragment>
                <nav
                    className={classnames({
                        'd-inline-flex': true,
                        [className]: !!className,
                    })}
                >
                    {this.renderResponsiveMenu(locationPath)}
                    {this.renderMainMenu(locationPath)}
                </nav>
                {this.renderLoginModalPop()}
                <CheerModalPop />
                {authedUser && <ReactInterval timeout={50000} enabled={true} callback={() => checkNewNotifications()} />}
            </Fragment>
        )
    }
}

function mapStateToProps({
    auth,
    app,
}) {
    return {
        authedUser: auth.user,
        login: app.login,
    }
}

export default withRouterConnectWrapper(mapStateToProps)(Navigator)
